import { create } from "zustand"
import type { RankingState } from "./types"

const useRankingStore = create<RankingState>((set) => ({
    rankings: undefined,
    asset: undefined,
    assetKey: undefined,
    sortingStep: undefined,
    sortingContext: undefined,
    pendingClarification: undefined,
    setRankings: (rankings, asset, assetKey) =>
        set({
            rankings: rankings ?? undefined,
            asset: asset ?? undefined,
            assetKey: assetKey ?? undefined,
            sortingStep: undefined,
            sortingContext: undefined,
            pendingClarification: undefined,
        }),
    setSortingResponse: (next_step, context, clarification) =>
        set({
            sortingStep: next_step ?? undefined,
            sortingContext: context ?? undefined,
            pendingClarification: clarification ?? undefined,
        }),
    clearRankings: () =>
        set({
            rankings: undefined,
            asset: undefined,
            assetKey: undefined,
            sortingStep: undefined,
            sortingContext: undefined,
            pendingClarification: undefined,
        }),
}))

export { useRankingStore }
